<script lang="ts" setup>
import { useLessonRoomStore } from '@stores/lesson-room'

import { useLessonRoomAnalytics } from '@hooks/lesson-room/lesson-room-analytics.hook'

import LessonRoomControlButton from '@Atoms/LessonRoom/LessonRoomControlButton.vue'

defineOptions({
  name: 'ButtonHowToJoin',
})

const lessonRoomStore = useLessonRoomStore()
const { trackClickGuide } = useLessonRoomAnalytics()

const handleClick = (): void => {
  trackClickGuide()
  lessonRoomStore.setGuideOpen(true)
}
</script>

<template>
  <LessonRoomControlButton
    :icon="{ name: 'circle-question' }"
    label="How to join"
    @click="handleClick"
  />
</template>
